import { template } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { fn } from '@ember/helper';
import { modifier } from 'ember-modifier';
export class Scroller extends Component<{
    Element: HTMLDivElement;
    Blocks: {
        default: [scrollToBottom: () => void];
    };
}> {
    withinElement: HTMLDivElement;
    ref = modifier((el1: HTMLDivElement)=>{
        this.withinElement = el1;
    });
    static{
        template(`
    <div ...attributes {{this.ref}}>
      {{yield (fn scrollToBottom this.withinElement)}}
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
let frame: number;
function scrollToBottom(element1: HTMLElement) {
    if (frame) {
        cancelAnimationFrame(frame);
    }
    frame = requestAnimationFrame(()=>{
        element1.scrollTo({
            top: element1.scrollHeight,
            left: 0,
            behavior: 'smooth'
        });
    });
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi92ZXJjZWwvcGF0aDAvdWkvc3JjL2NvbXBvbmVudHMvbG9ncy9zY3JvbGxlci5ndHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IENvbXBvbmVudCBmcm9tICdAZ2xpbW1lci9jb21wb25lbnQnO1xuaW1wb3J0IHsgZm4gfSBmcm9tICdAZW1iZXIvaGVscGVyJztcblxuaW1wb3J0IHsgbW9kaWZpZXIgfSBmcm9tICdlbWJlci1tb2RpZmllcic7XG5cbmV4cG9ydCBjbGFzcyBTY3JvbGxlciBleHRlbmRzIENvbXBvbmVudDx7XG4gIEVsZW1lbnQ6IEhUTUxEaXZFbGVtZW50O1xuICBCbG9ja3M6IHsgZGVmYXVsdDogW3Njcm9sbFRvQm90dG9tOiAoKSA9PiB2b2lkXSB9O1xufT4ge1xuICBkZWNsYXJlIHdpdGhpbkVsZW1lbnQ6IEhUTUxEaXZFbGVtZW50O1xuXG4gIHJlZiA9IG1vZGlmaWVyKChlbDogSFRNTERpdkVsZW1lbnQpID0-IHtcbiAgICB0aGlzLndpdGhpbkVsZW1lbnQgPSBlbDtcbiAgfSk7XG5cbiAgPHRlbXBsYXRlPlxuICAgIDxkaXYgLi4uYXR0cmlidXRlcyB7e3RoaXMucmVmfX0-XG4gICAgICB7e3lpZWxkIChmbiBzY3JvbGxUb0JvdHRvbSB0aGlzLndpdGhpbkVsZW1lbnQpfX1cbiAgICA8L2Rpdj5cbiAgPC90ZW1wbGF0ZT5cbn1cblxubGV0IGZyYW1lOiBudW1iZXI7XG5cbmZ1bmN0aW9uIHNjcm9sbFRvQm90dG9tKGVsZW1lbnQ6IEhUTUxFbGVtZW50KSB7XG4gIGlmIChmcmFtZSkge1xuICAgIGNhbmNlbEFuaW1hdGlvbkZyYW1lKGZyYW1lKTtcbiAgfVxuXG4gIGZyYW1lID0gcmVxdWVzdEFuaW1hdGlvbkZyYW1lKCgpID0-IHtcbiAgICBlbGVtZW50LnNjcm9sbFRvKHtcbiAgICAgIHRvcDogZWxlbWVudC5zY3JvbGxIZWlnaHQsXG4gICAgICBsZWZ0OiAwLFxuICAgICAgYmVoYXZpb3I6ICdzbW9vdGgnLFxuICAgIH0pO1xuICB9KTtcbn1cbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsT0FBTyxlQUFlLHFCQUFxQjtBQUMzQyxTQUFTLEVBQUUsUUFBUSxnQkFBZ0I7QUFFbkMsU0FBUyxRQUFRLFFBQVEsaUJBQWlCO0FBRTFDLE9BQU8sTUFBTSxpQkFBaUI7SUFDNUIsU0FBUztJQUNUO1FBQVUsVUFBVSxzQkFBc0IsSUFBSTs7O0lBRXRDLGVBQWUsZUFBZTtJQUV0QyxNQUFNLFNBQVMsQ0FBQyxLQUFJO1FBQ2xCLElBQUksQ0FBQyxhQUFhLEdBQUc7SUFDdkIsR0FBRztJQUVILE1BQUE7UUFBQSxTQUFVLENBQUE7Ozs7RUFJVixDQUFBLEVBQUE7WUFBQSxXQUFBLElBQVc7WUFBWDtnQkFBQSxPQUFBLEtBQUEsU0FBQSxDQUFBLEVBQVc7WUFBRDtRQUFBO0lBQUEsQ0FKQTtBQUtaO0FBRUEsSUFBSSxPQUFPLE1BQU07QUFFakIsU0FBUyxlQUFlLFVBQVMsV0FBVztJQUMxQyxJQUFJLE9BQU87UUFDVCxxQkFBcUI7SUFDdkI7SUFFQSxRQUFRLHNCQUFzQjtRQUM1QixTQUFRLFFBQVEsQ0FBQztZQUNmLEtBQUssU0FBUSxZQUFZO1lBQ3pCLE1BQU07WUFDTixVQUFVO1FBQ1o7SUFDRjtBQUNGIn0